import api from "../api"
import type { ProductTagColor } from "./productTagColors"
import type { DeepReadonly } from "vue"
import { useQuery } from "@tanstack/vue-query"
import { BASE_PRODUCT_TAGS_QUERY_KEY } from "../queryKeys"
import type { Ref } from "vue"

export type ProductTag = DeepReadonly<{
  id: string
  label: string
  color: ProductTagColor
  isHidden: boolean
}>

export const listProductTags = async (): Promise<
  ProductTag[]
> => {
  const response = await api.get<ProductTag[]>(
    "/products/product-tags/"
  )
  return response.body
}

export const useProductTags = () => {
  const { data, isFetching } = useQuery({
    queryKey: [BASE_PRODUCT_TAGS_QUERY_KEY],
    queryFn: () => listProductTags(),
    staleTime: 60 * 60 * 1000,
  })

  const getById = (productTagId: string) =>
    computed(() =>
      data.value?.find(
        (productTag) => productTag.id === productTagId
      )
    )
  return {
    data,
    isFetching,
    getById,
    asOptions: computed(
      () =>
        data.value?.map(({ label, id }) => ({
          value: id,
          label: label,
        })) || []
    ),
  }
}

export const useProductTag = (
  productTagId: string | Ref<string>
) => {
  const { data: allProductTags, isFetching } =
    useProductTags()
  const data = computed(() =>
    allProductTags.value?.find(
      (productTag) => productTag.id === productTagId
    )
  )

  return {
    data,
    isFetching,
  }
}
